<template>
  <div class="mt__main" style="background-color: #F7F8FA;">
    <div class="mt__banner"></div>
    <div class="mt__center">
      <div
        style="background-color: #FFFFFF;width:1200px;border:1px solid rgba(231,233,237,1)"
      >
        <div class="mt__content--main">
          <div style="padding:10px;">
            <!-- <div style="overflow: hidden;">
              <iframe
                title="公司地址"
                style="margin: -33px -5px -40px -3px;"
                width="604"
                height="389"
                src="https://j.map.baidu.com/s/yS4IFb"
              ></iframe>
            </div> -->
            <iframe
              title="公司地址"
              width="600"
              height="324"
              frameborder="0"
              src="https://f.amap.com/4UP8a_0696yjQ"
            ></iframe>
          </div>
          <div style="vertical-align:middle;padding-left:40px;">
            <h1>深圳市名通科技股份有限公司</h1>
            <p style="line-height:32px;font-size:16px;color:#666666;">
              &emsp;联系人：张小姐
              <br />联系电话：18620750109&nbsp;&nbsp;&nbsp;&nbsp;（HR）
              <br />
              &emsp;&emsp;&emsp;&emsp;&emsp;0755-86004500（总部）
              <br />
              &emsp;&emsp;&emsp;&emsp;&emsp;020-38808093&ensp;&nbsp;（广州分公司）
              <br />联系邮箱：hr@mastercom.cn
              <br />&emsp;&emsp;地址：深圳市南山区科技园科发路8号金融基地2栋10楼A/B区（总部）
              <br />
              &emsp;&emsp;&emsp;&emsp;&emsp;广州市天河区元岗横路16号天汇创意园C1座401（广州分公司）
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "contact",
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.$store.commit("activate", {
      activeName: "contact"
    });
  },
  updated() {},
  methods: {}
};
</script>
<style scoped>
.mt__banner {
  background-image: url("../assets/contact/carousel0.png");
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue